import { Injectable } from '@angular/core';
import { ApiService } from '../../../core/service/api.service';
import { Observable } from 'rxjs';
import { QuestionAnswer } from '../model/sales-validation.interface';

@Injectable({
  providedIn: 'root'
})
export class SalesValidationService {

  constructor(
    private apiSrv: ApiService
  ) {
  }

  getQuestionsAnswers(): Observable<QuestionAnswer[]> {
    return this.apiSrv.get('api/get-tree-questions-and-answers', { showError: true });
  }
}
